/**
 * @generated SignedSource<<eda67bed1a6710dc4ce234189102f91b>>
 * @relayHash 91afe04d280db2c73a1bfb73cf376fd2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b31503dee820ff4c6db5d90498895a0c51b3ce9ba9aa5c23c0ac0b68d0b3ab0d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
export type useFetchReleasesJiraBusinessCalendarQuery$variables = {
  first?: number | null | undefined;
  projectAris: ReadonlyArray<string>;
  releaseDateAfter?: AGG$Date | null | undefined;
  releaseDateBefore?: AGG$Date | null | undefined;
};
export type useFetchReleasesJiraBusinessCalendarQuery$data = {
  readonly jira: {
    readonly versionsForProjects: {
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
        readonly node: {
          readonly description: string | null | undefined;
          readonly doneIssues: {
            readonly totalCount: number;
          };
          readonly iconUrl: AGG$URL | null | undefined;
          readonly id: string;
          readonly inprogressIssues: {
            readonly totalCount: number;
          };
          readonly name: string;
          readonly project: {
            readonly avatar: {
              readonly __typename: "JiraAvatar";
              readonly large: string;
              readonly small: string | null | undefined;
            };
            readonly key: string;
            readonly name: string;
          };
          readonly releaseDate: AGG$DateTime;
          readonly startDate: AGG$DateTime | null | undefined;
          readonly status: JiraVersionStatus;
          readonly todoIssues: {
            readonly totalCount: number;
          };
          readonly versionId: string;
          readonly " $fragmentSpreads": FragmentRefs<"calendarReleaseForMultipleProjects_businessCalendar">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly hasNextPage: boolean;
      };
    } | null | undefined;
  } | null | undefined;
};
export type useFetchReleasesJiraBusinessCalendarQuery = {
  response: useFetchReleasesJiraBusinessCalendarQuery$data;
  variables: useFetchReleasesJiraBusinessCalendarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAris"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "releaseDateAfter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "releaseDateBefore"
},
v4 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": [
      "RELEASED",
      "UNRELEASED"
    ]
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "jiraProjectIds",
    "variableName": "projectAris"
  },
  {
    "kind": "Variable",
    "name": "releaseDateAfter",
    "variableName": "releaseDateAfter"
  },
  {
    "kind": "Variable",
    "name": "releaseDateBefore",
    "variableName": "releaseDateBefore"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v10 = {
  "kind": "ScalarField",
  "name": "status"
},
v11 = {
  "kind": "ScalarField",
  "name": "description"
},
v12 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v13 = {
  "kind": "ScalarField",
  "name": "releaseDate"
},
v14 = {
  "kind": "ScalarField",
  "name": "key"
},
v15 = {
  "kind": "ScalarField",
  "name": "large"
},
v16 = {
  "kind": "ScalarField",
  "name": "small"
},
v17 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v18 = [
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "statusCategories": "DONE"
    }
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v20 = [
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "statusCategories": "IN_PROGRESS"
    }
  }
],
v21 = [
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "statusCategories": "TODO"
    }
  }
],
v22 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v23 = [
  (v19/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useFetchReleasesJiraBusinessCalendarQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "versionsForProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v6/*: any*/),
                        "action": "NONE",
                        "path": "jira.versionsForProjects.edges.node.id"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v7/*: any*/),
                        "action": "NONE",
                        "path": "jira.versionsForProjects.edges.node.versionId"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v8/*: any*/),
                        "action": "NONE",
                        "path": "jira.versionsForProjects.edges.node.name"
                      },
                      (v9/*: any*/),
                      {
                        "kind": "RequiredField",
                        "field": (v10/*: any*/),
                        "action": "NONE",
                        "path": "jira.versionsForProjects.edges.node.status"
                      },
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "RequiredField",
                        "field": (v13/*: any*/),
                        "action": "NONE",
                        "path": "jira.versionsForProjects.edges.node.releaseDate"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraProject",
                          "kind": "LinkedField",
                          "name": "project",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v14/*: any*/),
                              "action": "NONE",
                              "path": "jira.versionsForProjects.edges.node.project.key"
                            },
                            {
                              "kind": "RequiredField",
                              "field": (v8/*: any*/),
                              "action": "NONE",
                              "path": "jira.versionsForProjects.edges.node.project.name"
                            },
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "RequiredField",
                                    "field": (v15/*: any*/),
                                    "action": "NONE",
                                    "path": "jira.versionsForProjects.edges.node.project.avatar.large"
                                  },
                                  (v16/*: any*/),
                                  (v17/*: any*/)
                                ]
                              },
                              "action": "NONE",
                              "path": "jira.versionsForProjects.edges.node.project.avatar"
                            }
                          ]
                        },
                        "action": "NONE",
                        "path": "jira.versionsForProjects.edges.node.project"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "alias": "doneIssues",
                          "args": (v18/*: any*/),
                          "concreteType": "JiraIssueConnection",
                          "kind": "LinkedField",
                          "name": "issues",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v19/*: any*/),
                              "action": "NONE",
                              "path": "jira.versionsForProjects.edges.node.doneIssues.totalCount"
                            }
                          ],
                          "storageKey": "issues(filters:{\"statusCategories\":\"DONE\"})"
                        },
                        "action": "NONE",
                        "path": "jira.versionsForProjects.edges.node.doneIssues"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "alias": "inprogressIssues",
                          "args": (v20/*: any*/),
                          "concreteType": "JiraIssueConnection",
                          "kind": "LinkedField",
                          "name": "issues",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v19/*: any*/),
                              "action": "NONE",
                              "path": "jira.versionsForProjects.edges.node.inprogressIssues.totalCount"
                            }
                          ],
                          "storageKey": "issues(filters:{\"statusCategories\":\"IN_PROGRESS\"})"
                        },
                        "action": "NONE",
                        "path": "jira.versionsForProjects.edges.node.inprogressIssues"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "alias": "todoIssues",
                          "args": (v21/*: any*/),
                          "concreteType": "JiraIssueConnection",
                          "kind": "LinkedField",
                          "name": "issues",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v19/*: any*/),
                              "action": "NONE",
                              "path": "jira.versionsForProjects.edges.node.todoIssues.totalCount"
                            }
                          ],
                          "storageKey": "issues(filters:{\"statusCategories\":\"TODO\"})"
                        },
                        "action": "NONE",
                        "path": "jira.versionsForProjects.edges.node.todoIssues"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "calendarReleaseForMultipleProjects_businessCalendar"
                      }
                    ]
                  }
                ]
              },
              (v22/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useFetchReleasesJiraBusinessCalendarQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "versionsForProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v8/*: any*/),
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "xsmall"
                              }
                            ]
                          },
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "projectTypeName"
                          }
                        ]
                      },
                      {
                        "alias": "doneIssues",
                        "args": (v18/*: any*/),
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": "issues(filters:{\"statusCategories\":\"DONE\"})"
                      },
                      {
                        "alias": "inprogressIssues",
                        "args": (v20/*: any*/),
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": "issues(filters:{\"statusCategories\":\"IN_PROGRESS\"})"
                      },
                      {
                        "alias": "todoIssues",
                        "args": (v21/*: any*/),
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": "issues(filters:{\"statusCategories\":\"TODO\"})"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "driver",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "JiraVersionPlanScenarioValues",
                        "kind": "LinkedField",
                        "name": "planScenarioValues",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "scenarioType"
                          },
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v22/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b31503dee820ff4c6db5d90498895a0c51b3ce9ba9aa5c23c0ac0b68d0b3ab0d",
    "metadata": {},
    "name": "useFetchReleasesJiraBusinessCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1ac078be3c6f7c265dc02f750d1be94e";

export default node;
